<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  <div class="col-12">
    <div class="tile opacity-container" [class.active]="savingPlans">
      @if (!savingPlans?.length) {
        <div class="d-flex justify-content-center align-items-center">
          <div class="text-center mt-4 mb-4">
            <h3>
              {{ 'savings-plan.my-savings-plans.no-plans.header' | transloco }}
            </h3>
            <div class="mt-2">
              {{ 'savings-plan.my-savings-plans.no-plans.hint' | transloco }}
            </div>
            <div class="mt-4 d-flex justify-content-center">
              <web-design-system-button type="secondary" data-zid="create-savingsplan" size="small" [routerLink]="add_savings_plan">
                {{ 'savings-plan.my-savings-plans.no-plans.button' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        </div>
      } @else {
        <div class="d-sm-flex justify-content-between align-items-center">
          <h5>
            {{ 'savings-plan.my-savings-plans.headline' | transloco }}
          </h5>
          <web-design-system-icon-button icon="add" data-zid="create-savingsplan-already" [routerLink]="add_savings_plan">{{
            'savings-plan.my-savings-plans.add' | transloco
          }}</web-design-system-icon-button>
        </div>

        @if (savingPlans | hasCrypto) {
          <shared-micar-contracts-nudging class="d-block mt-4" />
        }

        @if (!savingsPlansDirectDebitActive) {
          <div class="zero-surface grey-800 p-3 mt-4 mb-2 b-r-4">
            @if ((sepaFacade.loading$ | async) === false && (sepaFacade.hasSepa$ | async)) {
              <div
                class="zero-text p-small-reg course-green"
                [innerHTML]="
                  'savings-plan.my-savings-plans.direct-debit-inactive.hint-activated'
                    | transloco
                      : {
                          link: verwaltungKtoDepot,
                        }
                "
              ></div>
            } @else {
              <h5 class="zero-text p-big-bold">
                {{ 'savings-plan.my-savings-plans.direct-debit-inactive.header' | transloco }}
              </h5>
              <div class="zero-text p-small-reg pt-2">
                {{ 'savings-plan.my-savings-plans.direct-debit-inactive.hint' | transloco }}
              </div>
              <div class="d-flex justify-content-end pt-2">
                <web-design-system-button size="small" (click)="activateDirectDebit()">{{
                  'savings-plan.my-savings-plans.direct-debit-inactive.button' | transloco
                }}</web-design-system-button>
              </div>
              @if (sepaFacade.errorMessage$ | async; as errorMessage) {
                <div class="zero-text p-small-reg course-red text-center pt-2">{{ errorMessage }}</div>
              }
            }
          </div>
        } @else {
          <hr />
        }

        <table class="table-depot">
          <caption>
            Sparpläne Liste
          </caption>
          <thead>
            <tr>
              <th>
                {{ 'savings-plan.my-savings-plans.name' | transloco }}
                <br />
                {{ 'savings-plan.my-savings-plans.isin' | transloco }}
              </th>
              <th>
                {{ 'savings-plan.my-savings-plans.rate' | transloco }}
              </th>
              <th>
                {{ 'savings-plan.my-savings-plans.status' | transloco }}
              </th>
              <th>
                {{ 'savings-plan.my-savings-plans.interval' | transloco }}
              </th>
              <th>
                {{ 'savings-plan.my-savings-plans.dynamization' | transloco }}
                <web-design-system-icon (click)="openDynamizationInfo()" class="cursor-pointer" name="info" size="small" />
              </th>
              <th>
                {{ 'savings-plan.my-savings-plans.last-execution' | transloco }}
                <br />
                {{ 'savings-plan.my-savings-plans.next-execution' | transloco }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (plan of savingPlans; track plan.id) {
              <tr>
                <td>
                  <web-components-instrument-details-link data-zid="check-name" class="font-medium" [isin]="plan.isin">
                    {{ plan.instrumentName }}
                  </web-components-instrument-details-link>
                  <div data-zid="check-isin" class="font-light">
                    {{ plan.instrumentType === cryptoType ? plan.instrumentShortName : plan.isin }}
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-end">
                    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                      {{ 'savings-plan.my-savings-plans.rate' | transloco }}
                    </div>
                    <div data-zid="check-rate">
                      {{ plan.amount | currency }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-end">
                    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                      {{ 'savings-plan.my-savings-plans.status' | transloco }}
                    </div>
                    <div data-zid="check-state">
                      {{ 'savings-plan.my-savings-plans.states.' + plan.status | transloco }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-end">
                    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                      {{ 'savings-plan.my-savings-plans.interval' | transloco }}
                    </div>
                    <div data-zid="check-intervals">
                      {{ 'savings-plan.my-savings-plans.intervals.' + plan.interval | transloco }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-end">
                    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                      {{ 'savings-plan.my-savings-plans.dynamization' | transloco }}
                    </div>
                    <div data-zid="check-dynamization">
                      @if (plan?.dynamization) {
                        {{ plan.dynamization }} %
                      } @else {
                        <a
                          class="zero-text p-base-reg link link-secondary"
                          [routerLink]="[edit_savings_plan, plan.id]"
                          [queryParams]="{ dynamization: true }"
                        >
                          {{ 'savings-plan.my-savings-plans.activate' | transloco }}
                        </a>
                      }
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-end">
                    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                      {{ 'savings-plan.my-savings-plans.last-execution' | transloco }}
                      <br />
                      {{ 'savings-plan.my-savings-plans.next-execution' | transloco }}
                    </div>
                    <div class="text-right">
                      @if (plan?.lastExecutionError) {
                        <span class="zero-text p-base-bold course-red">
                          {{ plan.lastExecutionError }}
                        </span>
                      } @else if (plan?.lastExecDate) {
                        {{ plan.lastExecDate | date: 'dd.MM.yy' }}
                      } @else {
                        &mdash;
                      }
                      <br />
                      {{ plan.nextExecDate | date: 'dd.MM.yy' }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-end align-items-center">
                    <div data-zid="edit-savings-plan" [title]="'savings-plan.my-savings-plans.edit' | transloco">
                      @if (!isReady(plan.status)) {
                        <svg class="icon icon-24 icon-inactive mr-2">
                          <use xlink:href="/assets/img/svgs/svgset.svg#edit-form" />
                        </svg>
                      } @else {
                        <div class="btn-icon cursor-pointer mr-2" [routerLink]="[edit_savings_plan, plan.id]">
                          <svg class="icon icon-21">
                            <use xlink:href="/assets/img/svgs/svgset.svg#edit-pencil" />
                          </svg>
                        </div>
                      }
                    </div>
                    <div data-zid="delete-savings-plan" [title]="'savings-plan.my-savings-plans.delete' | transloco">
                      @if (!isReady(plan.status)) {
                        <div class="btn-icon cursor-pointer">
                          <svg class="icon icon-21">
                            <use xlink:href="/assets/img/svgs/svgset.svg#bin" />
                          </svg>
                        </div>
                      } @else {
                        <div class="btn-icon cursor-pointer" (click)="askForDeletion(plan)">
                          <svg class="icon icon-21">
                            <use xlink:href="/assets/img/svgs/svgset.svg#bin" />
                          </svg>
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
              @if (isAskingForDeletion(plan)) {
                <tr>
                  <td colspan="7">
                    <div class="row">
                      <div class="col-12">
                        <div class="d-flex justify-content-center mb-2">
                          <web-components-trading-session (authorizationState)="isAuthorized = $event" />
                        </div>
                        <div data-zid="delete-savings-plan-confirm" class="d-flex justify-content-center align-items-center">
                          <web-design-system-button
                            class="mr-3"
                            type="secondary"
                            size="small"
                            [disabled]="!isAuthorized"
                            (click)="delete(plan)"
                          >
                            {{ 'savings-plan.my-savings-plans.delete' | transloco }}
                          </web-design-system-button>
                          <a class="link-secondary cursor-pointer" (click)="abortDeletion(plan)">
                            {{ 'savings-plan.my-savings-plans.abort' | transloco }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>

<ng-template #dynamizationInfo let-modal>
  <web-design-system-modal (dismiss)="modal.dismiss()">
    <div class="zero-text p-base-reg">{{ 'savings-plan.savings-plan-form.dynamic.modal' | transloco }}</div>
  </web-design-system-modal>
</ng-template>
